import {ApDynformsConfigFieldset}                                                 from '../../../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigNumerictextbox
}                                                                                 from '../../../../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {
  nameOf
}                                                                                 from '../../../../../ap-core/utils/ap-name-of';
import {IPpPlanningWizardDetailsFormData, IPpPlanningWizardDetailsResponsiveData} from '../../pp-planning-wizard.types';
import {
  AgriportConstantsService
}                                                                                 from '../../../../../services/common/agriport-constants.service';
import {
  ApDynformsValidator
}                                                                                 from '../../../../../ap-dynforms/ap-dynforms-validator';
import {Validators}                                                               from '@angular/forms';
import {
  ApDynformsConfigCheckbox
}                                                                                 from '../../../../../ap-dynforms/config/ap-dynforms-config-checkbox';
import {
  ApTranslationService
}                                                                                 from '../../../../../ap-utils/service/ap-translation.service';
import {
  ApDynformsConfigPlaceholder
}                                                                                 from '../../../../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {Injectable}                                                               from '@angular/core';
import {
  AgriportConstantsEnum
}                                                                                 from '../../../../../ap-interface/enums/ap-agriport-constants.enum';

@Injectable()
export class DetailsTargetRateMapPerPlanUiProvider {
  constructor(private translationService: ApTranslationService,
              private agriportConstantsService: AgriportConstantsService) {
  }

  /**
   * FieldSets for operationMode target rate
   */
  public createTargetRateMapPerPlanFieldset(responsiveData: IPpPlanningWizardDetailsResponsiveData): ApDynformsConfigFieldset[] {
    return [
      new ApDynformsConfigFieldset({
        legend: 'Global__Agronomy',
        key: 'Agronomy',
        config: [
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IPpPlanningWizardDetailsFormData>('ECStage'),
            label: 'Global__ECStage',
            decimals: 0,
            format: 'n0',
            min: +this.agriportConstantsService.GetConstant(AgriportConstantsEnum.EcMin),
            max: +this.agriportConstantsService.GetConstant(AgriportConstantsEnum.EcMax),
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'}),
            ]
          }),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IPpPlanningWizardDetailsFormData>('NUptakeAverage'),
            label: `${this.translationService.translate('AvgNUptakeShort')}  ${this.translationService.translate('Nutrients__kg_N_per_ha')}`,
            disabled: true
          })
        ]
      }),
      new ApDynformsConfigFieldset({
        legend: `${this.translationService.translate('Global__Water')} [${this.translationService.translate('Unit_l_per_ha')}]`,
        key: 'Global__Water',
        config: [
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IPpPlanningWizardDetailsFormData>('WaterAvg'),
            label: 'Global__Avg_Water',
            min: responsiveData?.MinWaterAvg$,
            max: 500,
            decimals: 0,
            format: 'n0',
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
            ]
          }),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IPpPlanningWizardDetailsFormData>('WaterRange'),
            label: 'Global__Working_Range',
            min: 0,
            max: responsiveData?.MaxWaterRange$,
            decimals: 0,
            format: 'n0',
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
            ]
          }),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IPpPlanningWizardDetailsFormData>('WaterMin'),
            label: 'Global__RateMin',
            disabled: true,
            decimals: 0,
            format: 'n0'
          }),
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IPpPlanningWizardDetailsFormData>('WaterMax'),
            label: 'Global__RateMax',
            disabled: true,
            decimals: 0,
            format: 'n0'
          }),
          new ApDynformsConfigCheckbox({
            key: nameOf<IPpPlanningWizardDetailsFormData>('WaterSetZeroAtMin'),
            label: 'PP_Set_Zero_At_Water_Min'
          }),
          new ApDynformsConfigPlaceholder()
        ]
      })
    ];
  }
}
